import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propStr, propValidate, } from '../../../../../helpers/custom-prop-types';
import SolutionBaseInput from './Base/SolutionBaseInput';
import InputTitle from './InputTitle';
const SolutionPoint = (props) => {
    const { isRequired, label, validate1, validate2, validate3 } = props;
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx(InputTitle, { isRequired: isRequired, label: label, tip: '' }), _jsx("div", { children: _jsx(Field, { component: SolutionBaseInput, name: 'point1', placeholder: '１つめのポイント（49文字以内）', type: 'text', validate: validate1 }) }), _jsx("div", Object.assign({ className: 'mt05' }, { children: _jsx(Field, { component: SolutionBaseInput, name: 'point2', placeholder: '２つめのポイント（49文字以内）', type: 'text', validate: validate2 }) })), _jsx("div", Object.assign({ className: 'mt05' }, { children: _jsx(Field, { component: SolutionBaseInput, name: 'point3', placeholder: '３つめのポイント（49文字以内）', type: 'text', validate: validate3 }) }))] })));
};
SolutionPoint.propTypes = {
    isRequired: propBool(),
    label: propStr().isRequired,
    validate1: propValidate().isRequired,
    validate2: propValidate().isRequired,
    validate3: propValidate().isRequired,
};
SolutionPoint.defaultProps = {
    isRequired: false,
};
export default SolutionPoint;
